import { useEffect, useState } from "react";

export const CustomCursor = () => {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [isHovering, setIsHovering] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only on desktop
    if (window.matchMedia("(pointer: coarse)").matches) return;

    const move = (e) => {
      setPos({ x: e.clientX, y: e.clientY });
      if (!isVisible) setIsVisible(true);
    };

    const handleOver = (e) => {
      const el = e.target;
      if (
        el.tagName === "BUTTON" ||
        el.tagName === "A" ||
        el.closest("button") ||
        el.closest("a") ||
        el.style.cursor === "pointer" ||
        el.closest("[class*=cursor-pointer]")
      ) {
        setIsHovering(true);
      } else {
        setIsHovering(false);
      }
    };

    const leave = () => setIsVisible(false);
    const enter = () => setIsVisible(true);

    document.addEventListener("mousemove", move);
    document.addEventListener("mouseover", handleOver);
    document.addEventListener("mouseleave", leave);
    document.addEventListener("mouseenter", enter);

    return () => {
      document.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", handleOver);
      document.removeEventListener("mouseleave", leave);
      document.removeEventListener("mouseenter", enter);
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <>
      {/* Outer glow ring */}
      <div
        className="fixed pointer-events-none z-[9999]"
        style={{
          left: pos.x,
          top: pos.y,
          width: isHovering ? "48px" : "32px",
          height: isHovering ? "48px" : "32px",
          borderRadius: "50%",
          border: `1.5px solid ${isHovering ? "rgba(123,104,238,0.5)" : "rgba(123,104,238,0.25)"}`,
          transform: "translate(-50%, -50%)",
          transition: "width 0.25s ease, height 0.25s ease, border-color 0.25s ease",
          mixBlendMode: "screen",
        }}
      />
      {/* Inner dot */}
      <div
        className="fixed pointer-events-none z-[9999]"
        style={{
          left: pos.x,
          top: pos.y,
          width: isHovering ? "6px" : "4px",
          height: isHovering ? "6px" : "4px",
          borderRadius: "50%",
          background: "#7B68EE",
          transform: "translate(-50%, -50%)",
          transition: "width 0.15s ease, height 0.15s ease",
          boxShadow: "0 0 10px rgba(123,104,238,0.4)",
        }}
      />
    </>
  );
};
